/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { Routes, Route, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Soft UI Dashboard React examples
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Soft UI Dashboard React themes
import theme from "assets/theme";

// Soft UI Dashboard React routes
import routes from "routes";
import { Alert, Snackbar } from "@mui/material";
// import { setAlertMessage, setUnreadCount } from "context/common/action";
import { setAlertMessage } from "context/common/action";
// Soft UI Dashboard React contexts
import { useSoftUIController } from "context";

// Images
import brand from "assets/images/logo-ct.png";
import "./App.css";
import "./styles/app.scss";
import { setMiniSidenav } from "context/theme/action";
import Loading from "components/Loading";
// import UserService from "service/UserSerivce";
import ProtectedRoute from "ProtectedRoute";
import FloatingContactBox from "FloatingContactBox";
// import bgImg from "./assets/images/bgIm3.jpg";

theme.components.MuiCard.styleOverrides.root.overflow = "unset";

export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, sidenavColor } = controller.theme;
  const { alertMessage, loading } = controller.common;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const [filterRoutes] = useState(routes);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
    const buildVersion = document
      .querySelector('meta[name="build-version"]')
      ?.getAttribute("content");

    console.log("🚀 Phiên bản build:", buildVersion);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        if (route.public) {
          return <Route exact path={route.route} element={route.component} key={route.key} />;
        }
        return (
          <Route
            exact
            path={route.route}
            element={
              <ProtectedRoute permissionCode={route.permissionCode}>
                {route.component}
              </ProtectedRoute>
            }
            key={route.key}
          />
        );
      }

      return null;
    });
  return (
    <div
      className="wrapper"
      style={{
        // backgroundImage: `url(${bgImg})`,
        backgroundColor: "#f2f4f7",
        overflowX: "auto",
      }}
    >
      <ThemeProvider theme={theme}>
        <Loading loading={loading} />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={5000}
          open={alertMessage.openAlert}
          onClose={(e, reason) => {
            if (reason === "clickaway") return;
            setAlertMessage(dispatch, { ...alertMessage, openAlert: false });
          }}
        >
          <Alert severity={alertMessage.type} sx={{ width: "100%" }}>
            {alertMessage.message}
          </Alert>
        </Snackbar>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Dashboard"
              routes={filterRoutes.filter((item) => item.noneSidebar !== true)}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            {/* <Configurator /> */}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(filterRoutes)}
          <Route path="/" element={<Navigate to="/" />} />
        </Routes>
        <FloatingContactBox />
      </ThemeProvider>
    </div>
  );
}
